import Vue from "vue";
import { URL_API } from "../../settings/apiConnect";

export default {
    state: {
        // массив записей текущей страницы
        eventLogData: []
    },

    mutations: {
        updateLog(state, payload) {
            state.eventLogData = Array.isArray(payload) ? payload : [];
        }
    },

    actions: {
        /**
         * payload: { page, perPage, userId, dateFrom, dateTo } или number (page).
         * Возвращает массив записей (может быть пустой).
         */
        async getEventLog({ commit }, payload) {
            let page = 1;
            let perPage = 10;
            let userId = null;
            let dateFrom = null;
            let dateTo = null;

            if (typeof payload === "number") {
                page = payload || 1;
            } else if (payload && typeof payload === "object") {
                page = payload.page || 1;
                perPage = payload.perPage || 10;
                userId = payload.userId || null;
                dateFrom = payload.dateFrom || null;
                dateTo = payload.dateTo || null;
            }

            const params = new URLSearchParams();
            params.append("data_per_page", perPage);
            params.append("order_by", "desc");
            params.append("page", page);

            if (userId) params.append("user_id", userId);
            if (dateFrom) params.append("date_from", dateFrom);
            if (dateTo) params.append("date_to", dateTo);

            try {
                const response = await Vue.axios.get(
                    `${URL_API}event-log?${params.toString()}`
                );

                const data = Array.isArray(response && response.data)
                    ? response.data
                    : [];

                commit("updateLog", data);
                return data;
            } catch (error) {
                console.error("getEventLog error:", error);
                commit("updateLog", []);
                return [];
            }
        }
    },

    getters: {
        logData(state) {
            return state.eventLogData;
        }
    }
};
